// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取每日股评文章评论 GET /content-team/article/comment/list */
export async function contentTeamArticleCommentListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamArticleCommentListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListArticleCommentItem>('/content-team/article/comment/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 发布文章评论 POST /content-team/article/comment/send */
export async function contentTeamArticleCommentSendUsingPOST(
  body: API.SubmitArticleCommentReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultArticleCommentItem>('/content-team/article/comment/send', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取每日股评文章详情 GET /content-team/article/detail */
export async function contentTeamArticleDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamArticleDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamDailyArticleDetail>('/content-team/article/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 文章点赞（取消） POST /content-team/article/like */
export async function contentTeamArticleLikeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamArticleLikeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/article/like', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 按内容主获取每日股评 GET /content-team/article/list */
export async function contentTeamArticleListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamArticleListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListTeamDailyArticleItem>('/content-team/article/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取内容主支付链接 GET /content-team/payment-url */
export async function contentTeamPaymentUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamPaymentUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultContentTeamPaymentUrlResp>('/content-team/payment-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 问诊满意度调查 POST /content-team/qa/feedback */
export async function contentTeamQaFeedbackUsingPOST(
  body: API.TeamQaFeedbackReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/qa/feedback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取聊天室问诊详情 GET /content-team/qa/info */
export async function contentTeamQaInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamQaInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultContentTeamQaInfoResp>('/content-team/qa/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户问诊列表 GET /content-team/qa/my-list */
export async function contentTeamQaMyListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamQaMyListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListContentTeamQaMessageResp>('/content-team/qa/my-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 催单 POST /content-team/qa/push */
export async function contentTeamQaPushUsingPOST(
  body: API.TeamQaPushReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/qa/push', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户问诊剩余次数 GET /content-team/qa/remain-count */
export async function contentTeamQaRemainCountUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamQaRemainCountUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamQaRemainCountResp>('/content-team/qa/remain-count', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建问诊消息 POST /content-team/qa/submit */
export async function contentTeamQaSubmitUsingPOST(
  body: API.TeamQaSubmitReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamQaSubmitResp>('/content-team/qa/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 内容主视频评论列表 GET /content-team/short-video/comment/list */
export async function contentTeamShortVideoCommentListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoCommentListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListShortVideoCommentListResp>(
    '/content-team/short-video/comment/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 内容主视频发表评论 POST /content-team/short-video/comment/send */
export async function contentTeamShortVideoCommentSendUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoCommentSendUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/short-video/comment/send', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 内容主视频信息 GET /content-team/short-video/info */
export async function contentTeamShortVideoInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamShortVideoResp>('/content-team/short-video/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 视频点赞/取消点赞 POST /content-team/short-video/like */
export async function contentTeamShortVideoLikeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoLikeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/short-video/like', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取内容主短视频列表 GET /content-team/short-video/list */
export async function contentTeamShortVideoListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListShortVideoResp>('/content-team/short-video/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取播放信息 GET /content-team/short-video/play-info */
export async function contentTeamShortVideoPlayInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamShortVideoPlayInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultGetPlayInfoResponse>('/content-team/short-video/play-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 评论列表 GET /content-team/stream-message/comment/list */
export async function contentTeamStreamMessageCommentListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamStreamMessageCommentListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStreamMessageCommentResp>(
    '/content-team/stream-message/comment/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 发送评论 POST /content-team/stream-message/comment/send */
export async function contentTeamStreamMessageCommentSendUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamStreamMessageCommentSendUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/stream-message/comment/send', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取内容主解盘消息详情 GET /content-team/stream-message/detail */
export async function contentTeamStreamMessageDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamStreamMessageDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamStreamMessageDetail>('/content-team/stream-message/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改解盘点赞状态 PUT /content-team/stream-message/like */
export async function contentTeamStreamMessageLikeUsingPUT(
  body: API.UserUpdateStreamMessageLikeReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/content-team/stream-message/like', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 按内容主获取解盘消息列表 GET /content-team/stream-message/list */
export async function contentTeamStreamMessageListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamStreamMessageListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListTeamStreamMessageItem>('/content-team/stream-message/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 内容主信息 GET /content-team/team-info */
export async function contentTeamTeamInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentTeamTeamInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultContentTeamItem>('/content-team/team-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
